import dayjs from 'dayjs';

import { IUserForm } from './types';
import { IUser } from '../../../../types/user.type';

export const createInitialValues = (user: IUser): IUserForm => ({
  firstname: user.firstname,
  lastname: user.lastname,
  email: user.email,
  phone: user.phone,
  linkedin: user.linkedin ?? '',
  birthday: user.birthday ? dayjs(user.birthday) : null,
  available: user.available ?? '',
  date_available: user.date_available ? dayjs(user.date_available) : null,
  address: user.address ?? '',
  address_secondary: user.address_secondary ?? '',
  postalcode: user.postalcode ?? '',
  city: user.city ?? '',
  country: user.country ?? '',
  email_secondary: user.email_secondary ?? '',
  phone_professional: user.phone_professional ?? '',

  cv: '',
  cv_fr: '',
});
